export default __webpack_public_path__ + "static/media/send.8ad4d4b2.svg";